const DEEP_LINK_DOMAIN = 'https://spotto.pl';

export function generateBookingLink(businessProfileId: string): string {
  return `${DEEP_LINK_DOMAIN}/book/${businessProfileId}`;
}

export function generateProductLink(productId: string): string {
  return `${DEEP_LINK_DOMAIN}/product/${productId}`;
}

async function writeToClipboard(text: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // fall through to legacy fallback
    }
  }

  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}

export function copyBookingLink(businessProfileId: string): Promise<boolean> {
  return writeToClipboard(generateBookingLink(businessProfileId));
}

export function copyProductLink(productId: string): Promise<boolean> {
  return writeToClipboard(generateProductLink(productId));
}
